import { useState } from 'react';
import { PartnerSidebar } from '@/components/sidebars';

export function PartnerLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return <PartnerSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />;
}
